import { css } from '@emotion/react';
import { PlayerLayout } from '@core/player/types';
import { useVideoPlayerStore } from '@embed/components/VideoPlayer/store';
import { videoPlayerAvailableHeightSelector, videoPlayerLayoutSelector, } from '@embed/components/VideoPlayer/store/selectors';
import Modal from '@player/components/Modal';
import { Z_MODAL } from '../constants/zIndexes';
import { usePlayerModalWrapperPosition } from '../hooks/usePlayerModalWrapperPosition';
import { useStore } from '../store';
export var PlayerModalPosition;
(function (PlayerModalPosition) {
    /**
     * Modal covers the entire widget area edge-to-edge.
     */
    PlayerModalPosition["COVER"] = "cover";
    /**
     * Modal appears in the center maintaining 9:16 aspect ratio
     * covering the video tile edge-to-edge.
     */
    PlayerModalPosition["CENTER"] = "center";
    /**
     * Modal appears at the right edge of the widget area.
     */
    PlayerModalPosition["RIGHT"] = "right";
})(PlayerModalPosition || (PlayerModalPosition = {}));
/**
 * PlayerModal component for Player3's modals. Uses store subscriptions
 * to modify the behavior exposed by Modal.Wrapper.
 */
export const PlayerModal = ({ children, position, wrapperCss, ...props }) => {
    const availableHeight = useVideoPlayerStore(videoPlayerAvailableHeightSelector);
    const layout = useVideoPlayerStore(videoPlayerLayoutSelector);
    const params = useStore((state) => state.params);
    const isVisible = useStore((state) => state.isVisible);
    const wrapperPosition = usePlayerModalWrapperPosition(position);
    return (<div data-testid={props?.testId} css={css `
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: ${Z_MODAL};
        zoom: var(--ui-zoom);

        --wrapper-border-radius: ${layout === PlayerLayout.FULLSCREEN
            ? '0'
            : 'var(--border-radius, 0)'};

        border-radius: var(--wrapper-border-radius);
        overflow: hidden;
        transform: translate3d(0, 0, 0);
      `}>
      <Modal.Wrapper css={css `
          background: linear-gradient(
            180deg,
            rgb(0 0 0 / 40%) 0%,
            rgb(0 0 0 / 100%) 100%
          );

          border-radius: var(--wrapper-border-radius);

          /* Aspect ratio thing */
          height: 100%;
          width: 100%;

          position: absolute;

          ${wrapperPosition === PlayerModalPosition.COVER &&
            css `
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          `}

          ${wrapperPosition === PlayerModalPosition.CENTER &&
            css `
            aspect-ratio: 9/16;
            overflow: hidden;
            width: auto;
            top: 0;
            left: 50%;
            transform: translateX(-50%);

            @supports not (aspect-ratio: 9/16) {
              width: ${(9 / 16) * (availableHeight || 0)}px;
            }
          `}

          ${wrapperPosition === PlayerModalPosition.RIGHT &&
            css `
            right: 0;
          `}
          ${wrapperCss}
        `} backdropCss={css `
          background: transparent;
        `} branding={params?.branding} disableFocusTrap={!isVisible || params?.a11y_disable_focus} {...props}>
        {children}
      </Modal.Wrapper>
    </div>);
};
